export default __webpack_public_path__ + "static/media/photo--sm--34.70b58aef.jpg";